import { render, staticRenderFns } from "./DropResourceOnProjectModal.vue?vue&type=template&id=3e26c760"
import script from "./DropResourceOnProjectModal.vue?vue&type=script&lang=js"
export * from "./DropResourceOnProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports